import { GetToken } from './token';

export async function ApiRequest(method, data, url, headers, token) {
  if (!token) {
    const stoken = GetToken();
    token = JSON.parse(stoken).token;
  }

  const requestOptions = {
    method: method,
    headers: headers
      ? headers
      : token
      ? {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      : undefined,
    body: data,
  };

  return await fetch(url, requestOptions).then(handleErrors);
}

export async function ApiRequestNoJson(method, data, url, token) {
  if (!token) {
    const stoken = GetToken();
    token = JSON.parse(stoken).token;
  }

  const requestOptions = {
    method: method,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: data,
  };

  return await fetch(url, requestOptions).then(handleErrors);
}

function handleErrors(response) {
  if (!response.ok) {
    if (response.status === 401) {
      window.location.replace('https://admin.improxy.com/');
    }
  }
  return response;
}
